<template>
  <div class="content">
    <div class="info-panel" :style="bookingCardStyles">
      <div class="left">
        <div class="heading">
          <h1>{{ booking.title }}</h1>
          <h2>{{ booking.description }}</h2>
        </div>
        <div class="detail">
          <div class="schedule">{{ schedule }}</div>
          <div class="organizer">Organizer: {{ email }}</div>
        </div>
        <div class="action-buttons">
          <div :class='`pin-entry-container ${pinStatus}`'>
            <PinEntry @statusChange="handlePinStatusChange" @success="handlePinSuccess" />
          </div>
          <div class="right-buttons">
            <CheckinButton
              v-if="canCheckin(booking)"
              :id="booking.id"
            />
            <EditButton
              v-if="pinStatus === 'unlocked' && canUpdateBooking(booking)"
              :id="booking.id"
            />
            <DeleteButton
              :id="booking.id"
              v-if="pinStatus === 'unlocked' && canDeleteBooking"
              @success="handleDeleteSuccess"
            />
          </div>
        </div>
      </div>
      <div class="right">
        <h3>Invitees</h3>
        <InviteeList :invitees="invitesList" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

import PinEntry from '../PinEntry';
import InviteeList from '../Invites/List';
import BookingMixins from '../../../mixins/booking-mixins';
import PermissionMixins from '../../../mixins/permission-mixins';
import DeleteButton from '../ActionButtons/Delete';
import EditButton from '../ActionButtons/Edit';
import CheckinButton from '../ActionButtons/Checkin';

export default {
  mixins: [BookingMixins, PermissionMixins],

  components: { InviteeList, PinEntry, DeleteButton, EditButton, CheckinButton },

  data: () => ({
    pinStatus: 'locked',
    user: null,
  }),

  computed: {
    ...mapState({
      backgroundColor: state => state.space.calendar_color,
    }),

    bookingCardStyles() {
      document.documentElement.style.setProperty('--primary', this.backgroundColor);
      return {
        backgroundColor: this.backgroundColor,
      };
    },
  },

  methods: {
    ...mapActions(['refreshBookings']),

    handlePinStatusChange(status) {
      this.pinStatus = status;

      if (status !== 'unlocked') {
        this.user = null;
        this.auth.user_role = null;
        this.auth.user_id = null;
      }
    },

    handlePinSuccess({ result }) {
      this.user = result;
      this.auth.user_role = result.user_role;
      this.auth.user_id = result.id;
    },

    handleDeleteSuccess() {
      this.$emit('deleted');
      this.$emit('close');

      this.refreshBookings();
    },

    canCheckin(booking) {
      return this.pinStatus === 'unlocked' && this.canUpdateBooking(booking) && !this.booking.checkedin;
    },
  },
};
</script>


<style lang="scss" scoped>
  .content {
    overflow: visible;

    h1 {
      color: #fff;
      font-size: 4em;
      font-weight: bold;
      letter-spacing: -0.47px;
      line-height: 68px;
      text-shadow: 9px 4px rgba(0,0,0,0.04);
    }

    h2 {
      color: #fff;
      font-size: 2em;
      letter-spacing: -0.19px;
      line-height: 27px;
      font-weight: normal;
    }

    h3 {
      color: #363636;
      font-size: 2.5em;
      letter-spacing: -0.21px;
      line-height: 30px;
      font-weight: normal;
    }

    .info-panel {
      display: flex;
      border-radius: 24px;
      justify-content: space-between;
    }

    .left, .right {
      padding: 30px;
      height: 90vh;
    }

    .left {
      flex: 1;
      color: #fff;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .schedule {
        font-size: 42px;
        letter-spacing: -0.36px;
        line-height: 51px;
      }

      .organizer {
        font-size: 22px;
        letter-spacing: -0.19px;
        line-height: 27px;
      }
    }

    .right {
      width: 30vw;
      border-radius: 24px;
      background-color: #FFFFFF;
    }

    .action-buttons {
      position: relative;
      height: 75px;
      display: flex;

      .pin-entry-container {
        position: absolute;
        left: -65px;
        flex: 0;
      }

      .right-buttons {
        display: flex;
        flex: 1;
        width: 100%;
        justify-content: flex-end;

        > div.btn {
          margin-left: 20px;
        }
      }
    }
  }

  @media only screen and (max-width: 720px) {
    .content {
      h1, h2, h3 {
        line-height: initial;
      }

      h1 {
        font-size: 3em;
      }

      h2 {
        font-size: 2em;
      }

      h3 {
        font-size: 2.2em;
      }

      .left {
        .schedule {
          font-size: 2em;
        }

        .organizer {
          font-size: 1.2em;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Booking/Modal/BookingDetails.vue